import i18next from '../i18n';

export const availableMotifs = {
  [i18next.t('icons.abc', { ns: ['common'] })]: [
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-01.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-02.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-03.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-04.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-05.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-06.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-07.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-08.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-09.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-10.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-11.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-12.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-13.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-14.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-15.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-16.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-17.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-18.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-19.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-20.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-21.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-22.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-23.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-24.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-25.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-26.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-27.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-28.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-29.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-30.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-31.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-32.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-33.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-34.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-35.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-36.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-37.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-38.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-39.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-40.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-41.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-42.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-43.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-44.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-45.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-46.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-47.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-48.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-49.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-50.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-51.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-52.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-53.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-54.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-55.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-56.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-57.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-58.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-59.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-60.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-61.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-62.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-63.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-64.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-65.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-66.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-67.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-68.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-69.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-70.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-71.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-72.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-73.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/ABC_123/planetcards-Bibliotheque-2025-ABC-74.png',
      group: 'ABC_123',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
  ],
  [i18next.t('icons.animals', { ns: ['common'] })]: [
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-25.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-26.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-27.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-28.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-29.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-30.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-31.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-32.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-33.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-34.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-35.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-36.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-37.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-38.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-39.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-40.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-41.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-42.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-43.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-44.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-45.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-46.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-47.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-48.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-49.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux-50.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Abeille.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Dinosaure-Baleine-Goutte.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Dinosaure-Cygne-Reine.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Dinosaure-Line-Art-2.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Dinosaure-Line-Art.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Dinosaure-Tete-de-Lion.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Ecureuil.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Elephant.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Girafe.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Hippopotame.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Lapin-Assis.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Lapin.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Lion.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Oiseau-Colombe-Blanche-vegetal.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Oiseau-Colombe-Blanche.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Oiseau-Colombe-Claire.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Oiseau-Colombe-noire.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Ours-Brun.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Papillon-Rose.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Papillon.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Petit-Ours.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Renard.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Singe.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Animaux/planetcards-Bibliotheque-2025-animaux_planetcards-Bibliotheque-2023-Shopify-Theme-Animaux-Zebre.png',
      group: 'Animaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
  ],
  [i18next.t('icons.astro', { ns: ['common'] })]: [
    {
      name: '',
      src: '/motifs/Signes Astro/Balance.png',
      group: 'Signes Astro',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Signes Astro/Belier.png',
      group: 'Signes Astro',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Signes Astro/Cancer.png',
      group: 'Signes Astro',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Signes Astro/Capricorne.png',
      group: 'Signes Astro',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Signes Astro/Gemeaux.png',
      group: 'Signes Astro',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Signes Astro/Lion.png',
      group: 'Signes Astro',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Signes Astro/Poisson.png',
      group: 'Signes Astro',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Signes Astro/Sagittaire.png',
      group: 'Signes Astro',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Signes Astro/Scorpion.png',
      group: 'Signes Astro',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Signes Astro/Taureau.png',
      group: 'Signes Astro',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Signes Astro/Verseau.png',
      group: 'Signes Astro',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Signes Astro/Vierge.png',
      group: 'Signes Astro',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
  ],
  [i18next.t('icons.birth', { ns: ['common'] })]: [
    {
      name: '',
      src: '/motifs/Naissance/Agenda_blanc1.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/Agenda_blanc2.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/Agenda_noir.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Agenda_noir2.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Agenda_vegetal.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Arcenciel_bleu.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Arcenciel_noir.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Arcenciel_rose.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Balance_blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/Balance_noir.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Balance_vegetal.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Bateau.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Biberon.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Chaussures.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Couronne.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Doudou.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Etoile.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Hochet_fille.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Hochet_garcon.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Horloge_fine.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Horloge_vegetal.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Lune.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Nounou_fille.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Nounou_garcon.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Nuage-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/Nuage.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/Nuage_pluie.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Panier.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Poids_blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/Regle_blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/Regle_noir.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Regle_vegetal.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/Soleil.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-01.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-02.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-03.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-04.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-05.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-06.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-07.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-08.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-09.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-10.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-11.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-12.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-13.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-14.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-15.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-16.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-17.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-18.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-19.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-20.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-21.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-22.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-23.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-24.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-25.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-26.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-27.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-28.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-29.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-30.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-31.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-32.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-33.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-34-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-35.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-36.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-37.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-38.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-39.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-40.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-41.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-42.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-43.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-44.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-45.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-46-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-47-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-48-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-50.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-51-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-52-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-53-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-54-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-55-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-56-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-57-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-58-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-59-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-60-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-61-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-62-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-63-blanc.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-64.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-65.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-66.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-67.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-68.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Naissance/planetcards-Bibliotheque-2025-naissance-69.png',
      group: 'Naissance',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
  ],
  [i18next.t('icons.christmas', { ns: ['common'] })]: [
    {
      name: '',
      src: '/motifs/Noel-Hiver/Boule_aquarelle_kraft.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Boule_aquarelle.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Cadeau_aquarelle_bleu.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Cadeau_aquarelle_kraft.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Chaussette.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Flocon_blanc-blanc.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Flocon_blanc.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Flocon.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Houx_aquarelle.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Houx.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-02.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-03.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-04.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-05.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-06.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-07.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-08.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-09.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-10.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-11.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-12.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-13.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-14.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-15.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-16.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-17.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-18.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-19.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-20.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-21.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-22.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-23.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-24.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-25.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-26.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-27.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-28.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-29.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-30.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-31.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-32.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-33.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-34.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-35.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-36.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-37.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-38.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-39.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-40-blanc.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel-41-blanc.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/planetcards-Bibliotheque-2025-Noel_planetcards-Bibliotheque-2023-Shopify-Noel-Flocon-Blanc.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Renne.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Santa.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Sapin_aquarelle.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Sapin_blanc-blanc.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Sapin_blanc.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Sapin_dore.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Noel-Hiver/Sucreorge.png',
      group: 'Noel-Hiver',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
  ],
  [i18next.t('icons.flowers', { ns: ['common'] })]: [
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Bouquet_champetre1.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Bouquet_champetre2.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Bouquet_champetre_rose.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Couronne_fleurs_rose.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Eucalyptus1.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Eucalyptus2.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Eucalyptus_clair.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Eucalyptus_clair2.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Eucalyptus_coeur.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Eucalyptus_line.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Eucalyptus_line2.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Feuille.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Feuille_coeur.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Feuille_dore.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Feuille_fonce.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Feuille_tropicale.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Fleur_bleue.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Fleur_hiver_line.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Fleur_jaune.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Fleur_line.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Fleur_marguerite.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Fleur_marguerite2.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Fleur_marguerite_line.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Fleur_rose.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Fleur_violet.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Fougere.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Olivier.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Olivier_line.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Rose.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/Rose_blanche.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-01.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-02.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-03.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-04.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-05.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-06.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-07.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-08.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-09.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-10.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-11.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-12.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-13.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-14.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-15.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-16.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-17.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-18.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-19.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-20.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-21.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-22.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-23.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-25.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-26.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-27.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-28.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-29.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-33.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-34.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-35.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-36.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-37.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-38.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-39.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-40.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-41.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-42.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-43.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-44.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-45.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-46.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-47.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-48.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-50.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-51.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-52.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-53-blanc.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-54-blanc.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-55-blanc.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-56.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-57.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-58.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-59.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-60.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-61.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-62.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-63.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-64.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-65.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-66.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-67.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-68.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-69.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-70.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-71.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-72.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-73.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-74.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-75.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-76.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-77.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-78.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-79.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fleurs-Vegetaux/planetcards-Bibliotheque-2025-vegetal-80.png',
      group: 'Fleurs-Vegetaux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
  ],
  [i18next.t('icons.frames', { ns: ['common'] })]: [
    {
      name: '',
      src: '/motifs/Cadres/Carre.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/Rectangle1.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/Rectangle2.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/Rectangle3.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/Rectangle4.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/Rectangle_vegetal.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/Rond.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/Rond_vegetal.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/Rond_vegetal_euxalyptus.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/Rond_vegetal_fleur.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/Rond_vegetal_noir.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/Rond_vegetal_noir2.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/Rond_vegetal_noir3.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/planetcards-Bibliotheque-2025-cadre-14.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/planetcards-Bibliotheque-2025-cadre-15-blanc.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Cadres/planetcards-Bibliotheque-2025-cadre-16-blanc.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Cadres/planetcards-Bibliotheque-2025-cadre_planetcards-Bibliotheque-2023-Shopify-Theme-Cadres-Rectangles-Vegetal-2.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/planetcards-Bibliotheque-2025-cadre_planetcards-Bibliotheque-2023-Shopify-Theme-Cadres-Rond-Vegetal-2.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/planetcards-Bibliotheque-2025-cadre_planetcards-Bibliotheque-2023-Shopify-Theme-Cadres-Rond-Vegetal-Eucalyptus-blanc.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Cadres/planetcards-Bibliotheque-2025-cadre_planetcards-Bibliotheque-2023-Shopify-Theme-Cadres-Rond-Vegetal-Noir-2.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/planetcards-Bibliotheque-2025-cadre_planetcards-Bibliotheque-2023-Shopify-Theme-Cadres-Rond-Vegetal-Noir-3-blanc.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Cadres/planetcards-Bibliotheque-2025-cadre_planetcards-Bibliotheque-2023-Shopify-Theme-Cadres-Rond-Vegetal-Noir.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Cadres/planetcards-Bibliotheque-2025-cadre_planetcards-Bibliotheque-2023-Shopify-Theme-Cadres-Rond-Vegetal-et-Fleurs-blanc.png',
      group: 'Cadres',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
  ],
  [i18next.t('icons.icons', { ns: ['common'] })]: [
    {
      name: '',
      src: '/motifs/Pictos/Check.png',
      group: 'Pictos',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/Coeur_blanc.png',
      group: 'Pictos',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/Coeur_noir.png',
      group: 'Pictos',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/Ligne.png',
      group: 'Pictos',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/Point.png',
      group: 'Pictos',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/Sapin_noir.png',
      group: 'Pictos',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/Smiley_noir.png',
      group: 'Pictos',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/Soleil_noir.png',
      group: 'Pictos',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-01-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-02-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-03-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-04-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-05-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-06.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-07.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-08.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-09.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-10.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-11.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-12.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-13.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-14.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-15.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-16.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-17.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-18.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-19.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-20.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-21.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-22.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-23.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-24.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-25.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-26.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-27.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-28-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-29.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-30.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-31-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-32-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-33.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-34.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-35.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-36.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-37.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-38.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-39.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-40-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-41-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-42-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-43-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-44-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-45-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-46.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-47.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-48-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Pictos/planetcards-Bibliotheque-2025-divers-49-blanc.svg',
      group: 'Pictos',
      width: 172,
      height: 172,
      greyBackground: true,
    },
  ],
  [i18next.t('icons.party', { ns: ['common'] })]: [
    {
      name: '',
      src: '/motifs/Fete/Ballon.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/Ballons.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/Bougies.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/Confettis_colores.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/Confettis_dores.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/Fanions_colores.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/Fanions_jaune_bleu.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/Fanions_naissance.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/Feu_artifice_dore.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/Feu_artifice_dore2.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/Gateau.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/planetcards-Bibliotheque-2025-Fete_Fete-Anniversaire-apparareil-photo.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/planetcards-Bibliotheque-2025-Fete_Fete-Anniversaire-ballon-chien.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/planetcards-Bibliotheque-2025-Fete_Fete-Anniversaire-bouteille.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/planetcards-Bibliotheque-2025-Fete_Fete-Anniversaire-canette.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/planetcards-Bibliotheque-2025-Fete_Fete-Anniversaire-cerise-disco.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/planetcards-Bibliotheque-2025-Fete_Fete-Anniversaire-cocktail-1.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/planetcards-Bibliotheque-2025-Fete_Fete-Anniversaire-cocktail-2.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/planetcards-Bibliotheque-2025-Fete_Fete-Anniversaire-feu-artificice-3.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Fete/planetcards-Bibliotheque-2025-Fete_Fete-Anniversaire-gâteau-cerise.png',
      group: 'Fete',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
  ],
  [i18next.t('icons.religious', { ns: ['common'] })]: [
    {
      name: '',
      src: '/motifs/Religieux/Colombe.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/Colombe_blanche.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Religieux/Colombe_claire.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/Colombe_noire.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/Croix-blanc.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Religieux/Croix_vegetale1.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/Croix_vegetale2.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/Eglise_dore.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/Menorah.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-01.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-02.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-03.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-04.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-05-blanc.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-06.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-07-blanc.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-08.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-09.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-10-blanc.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-11.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-12.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-14-blanc.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-16-blanc.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-17.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-18.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-19-blanc.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-20.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-21.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-22-blanc.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-23.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-24.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-25.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-26-blanc.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-27.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-28.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-29.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-30-blanc.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-31-blanc.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-32.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-33.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Religieux/planetcards-Bibliotheque-2025-religieux-34-blanc.png',
      group: 'Religieux',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
  ],
  [i18next.t('icons.travel', { ns: ['common'] })]: [
    {
      name: '',
      src: '/motifs/Voyage/planetcards-Bibliotheque-2025-voyage-01.svg',
      group: 'Voyage',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Voyage/planetcards-Bibliotheque-2025-voyage-02.svg',
      group: 'Voyage',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Voyage/planetcards-Bibliotheque-2025-voyage-03.svg',
      group: 'Voyage',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Voyage/planetcards-Bibliotheque-2025-voyage-04.svg',
      group: 'Voyage',
      width: 172,
      height: 172,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Voyage/planetcards-Bibliotheque-2025-voyage-05-blanc.svg',
      group: 'Voyage',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Voyage/planetcards-Bibliotheque-2025-voyage-06-blanc.svg',
      group: 'Voyage',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Voyage/planetcards-Bibliotheque-2025-voyage-07-blanc.svg',
      group: 'Voyage',
      width: 172,
      height: 172,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Voyage/planetcards-Bibliotheque-2025-voyage-08-blanc.svg',
      group: 'Voyage',
      width: 172,
      height: 172,
      greyBackground: true,
    },
  ],
  [i18next.t('icons.wedding', { ns: ['common'] })]: [
    {
      name: '',
      src: '/motifs/Mariage/Appareilphoto_blanc.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Mariage/Appareilphoto_noir.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Assiette.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Bagues.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Bouledisco_blanc.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Mariage/Bouledisco_noir.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Champagne.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Couple.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Fleur.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Gateau.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Gateau_noir.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Mariage.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Micro.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Musique.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Musique2.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/Voiture.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-01.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-02.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-03.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-04.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-05.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-06.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-07.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-08.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-09.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-10.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: false,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-17-blanc.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-18-blanc.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-19-blanc.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-20-blanc.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-21-blanc.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-27-blanc.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-28-blanc.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
    {
      name: '',
      src: '/motifs/Mariage/planetcards-Bibliotheque-22025-Mariage-29-blanc.png',
      group: 'Mariage',
      width: 1772,
      height: 1772,
      greyBackground: true,
    },
  ],
};
